import { Container } from "react-bootstrap";
import { Blocks, Rings, TailSpin, Triangle } from "react-loader-spinner";
export const Loading = () => {
  return (
    <>
        <Container     
            style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
            }}
        >
            <Rings
                height="80"
                width="100%"
                color="#38ace7"
                ariaLabel="blocks-loading"
                wrapperStyle={{}}
                wrapperClass="blocks-wrapper"
                visible={true}
            />
        </Container>    
    </>
  );
};